export default __webpack_public_path__ + "static/bedroom_cover-15e51d6f1ce12ad9067966e94bbfd7c4.png";